<template>
  <div class="links">
    <div v-for="item,index in links" :key="index" v-show="item.name != declare && index < 5">
      <a v-if="item.name != '申报须知'" :href="item.link"  target="_blank" >
        <p class="over-p2">{{ item.name }}</p><i class="el-icon-right"></i>
      </a>
      <router-link v-else :to="{name:'declare'}"><p>申报须知</p><i class="el-icon-right"></i></router-link>
    </div>
  </div>
</template>
<script>
import { getVb100EnrollLink } from '@/service/main.js'
export default {
  data() {
    return {
      links: [],
      declare: '',
    }
  },
  created () {
    this.getVb100EnrollLink()
  },
  computed: {
    route_name() {
      return this.$route.name
    }
  },
  watch: {
    route_name(val) {
      if(val == 'declare'){
        this.declare = '申报须知'
      }else{
        this.declare = ''
      }
    }
  },
  methods: {
    async getVb100EnrollLink () {
      let res = await getVb100EnrollLink()
      if(res.status == 'success') {
        this.links = res.res
        if(this.$route.name == 'declare'){
          this.declare = '申报须知'
        }else{
          this.declare = ''
        }
      }
    },
    goToDeclare() {
      this.$router.push('declare')
    }
  }
}
</script>
<style lang="stylus" scoped>

.links
  position fixed
  bottom 44px
  // width 100vw
  display flex
  justify-content flex-end
  right 30px
  z-index 2001
  a
    width 80px
    height 80px
    border-radius 50%
    background linear-gradient(90deg, #D9BB9E, #C78E66)
    margin-right 20px
    display flex
    justify-content center
    align-items center
    flex-direction column
    color #FFFFFF
    font-size 14px
    font-weight 500
    cursor pointer
    &:hover
      background linear-gradient(90deg,  #C78E66,#D9BB9E)
    p 
      padding 0 10px
      line-height 16px
      font-size 12px
    i 
      margin-top 5px
</style>